<div class="register-container">
  <!-- Loading Overlay -->
  @if (loading()) {
    <div class="loading-overlay">
      <div class="spinner-container">
        <div class="rolling-circle">
          <div class="circle"></div>
        </div>
        <p class="loading-text">Creating your account...</p>
      </div>
    </div>
  }

  <div class="register-card">
    <!-- Header -->
    <div class="auth-header">
      <h1 class="auth-title">Create Account</h1>
      <p class="auth-subtitle">Join ArkifiHub and start exploring amazing stores</p>
    </div>

    <!-- Registration Form -->
    <form (ngSubmit)="onSubmit()" class="auth-form">
      <div class="form-row">
        <div class="form-group">
          <label for="firstName" class="form-label">First Name</label>
          <input
            type="text"
            id="firstName"
            pInputText
            [(ngModel)]="firstName"
            name="firstName"
            placeholder="John"
            class="form-input"
            autocomplete="given-name"
            required
          />
        </div>

        <div class="form-group">
          <label for="lastName" class="form-label">Last Name</label>
          <input
            type="text"
            id="lastName"
            pInputText
            [(ngModel)]="lastName"
            name="lastName"
            placeholder="Doe"
            class="form-input"
            autocomplete="family-name"
            required
          />
        </div>
      </div>

      <div class="form-group">
        <label for="email" class="form-label">Email Address</label>
        <input
          type="email"
          id="email"
          pInputText
          [(ngModel)]="email"
          name="email"
          placeholder="john.doe@example.com"
            class="form-input"
            autocomplete="email"
          required
        />
      </div>

      <div class="form-group">
        <label for="phone" class="form-label">Phone Number</label>
        <input
          type="tel"
          id="phone"
          pInputText
          [(ngModel)]="phone"
          name="phone"
          placeholder="07000332232"
            class="form-input"
            autocomplete="tel"
          pattern="[0-9]*"
          inputmode="numeric"
          (input)="onPhoneInput($event)"
          required
        />
        <p class="form-hint">Enter numbers only (no spaces or special characters)</p>
      </div>

      <div class="form-group">
        <label for="password" class="form-label">Password</label>
        <input
          type="password"
          id="password"
          pInputText
          [(ngModel)]="password"
          name="password"
          placeholder="Enter password (min 6 characters)"
            class="form-input"
            autocomplete="new-password"
          required
        />
      </div>

      <div class="form-group">
        <label for="confirmPassword" class="form-label">Confirm Password</label>
        <input
          type="password"
          id="confirmPassword"
          pInputText
          [(ngModel)]="confirmPassword"
          name="confirmPassword"
          placeholder="Confirm your password"
            class="form-input"
            autocomplete="new-password"
          required
        />
      </div>

      <div class="form-row">
        <div class="form-group">
          <label for="transactionPin" class="form-label">Transaction PIN</label>
          <input
            type="password"
            id="transactionPin"
            pInputText
            [(ngModel)]="transactionPin"
            name="transactionPin"
            placeholder="0000"
            class="form-input"
            maxlength="4"
            pattern="[0-9]*"
            inputmode="numeric"
            autocomplete="off"
            required
          />
          <p class="form-hint">4-digit PIN for transactions</p>
        </div>

        <div class="form-group">
          <label for="confirmTransactionPin" class="form-label">Confirm PIN</label>
          <input
            type="password"
            id="confirmTransactionPin"
            pInputText
            [(ngModel)]="confirmTransactionPin"
            name="confirmTransactionPin"
            placeholder="0000"
            class="form-input"
            maxlength="4"
            pattern="[0-9]*"
            inputmode="numeric"
            autocomplete="off"
            required
          />
        </div>
      </div>

      <button
        type="submit"
        pButton
        label="Create Account"
        icon="pi pi-user-plus"
        [loading]="loading()"
        class="submit-button"
      ></button>

      <div class="auth-footer">
        <p>
          Already have an account?
          <a routerLink="/signin" class="auth-link">Sign in here</a>
        </p>
      </div>
    </form>
  </div>
  
  <!-- Toast Notifications -->
  <p-toast position="bottom-right"></p-toast>
</div>
